import { Icon as MdiReactIcon } from '@mdi/react'
import React from 'react'

const MDI_BASE_SIZE = 24

type MdiIconProps = {
  path: string
  size?: number
} & Omit<React.ComponentProps<typeof MdiReactIcon>, 'path' | 'ref' | 'size'>

export const MdiIcon = React.forwardRef<SVGSVGElement, MdiIconProps>(
  ({ path, size, ...rest }, ref) => (
    <MdiReactIcon
      // @mdi/react's own types still declare `ref` as a plain `RefObject`, predating callback-ref support
      ref={ref as React.RefObject<SVGSVGElement>}
      path={path}
      size={typeof size === 'number' ? size / MDI_BASE_SIZE : undefined}
      {...rest}
    />
  ),
)
